var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOrbV2 = function SvgOrbV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.98,
    height: 66.011,
    viewBox: "0 0 65.98 66.011"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 32.984,
    cy: 32.984,
    transform: "translate(.006 .007)",
    fill: "#fff",
    r: 32.984
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M31.372.081A32.983 32.983 0 0 0 .041 34.638 32.984 32.984 0 0 0 34.599 65.97a32.984 32.984 0 0 0 31.326-34.557A32.984 32.984 0 0 0 31.372.081Zm15.375 20.385a21.4 21.4 0 0 1 7.885 15.567 21.474 21.474 0 0 1-20.4 22.5c-.186.009-.367-.006-.553 0a21.544 21.544 0 0 0 11.864-11.744 21.394 21.394 0 0 1-15.567 7.886 21.474 21.474 0 0 1-22.5-20.4c-.009-.186.006-.368 0-.553a21.544 21.544 0 0 0 11.749 11.859 21.4 21.4 0 0 1-7.885-15.567 21.473 21.473 0 0 1 20.4-22.5c.186-.009.367.006.553 0a21.544 21.544 0 0 0-11.868 11.751 21.393 21.393 0 0 1 15.567-7.885 21.473 21.473 0 0 1 22.5 20.4c.009.186-.006.368 0 .553a21.542 21.542 0 0 0-11.745-11.866Z",
    fill: "#b7fffd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M47.595 3.417A32.984 32.984 0 0 0 3.416 18.381 32.823 32.823 0 0 0 .025 34.294a36.553 36.553 0 0 1 10.811-21.177 32.187 32.187 0 0 1 20.481-8.775 32.2 32.2 0 0 1 21.241 6.732 36.619 36.619 0 0 1 12.9 20.279l.41-.02c.017-.11.025-.222.04-.332A32.962 32.962 0 0 0 47.595 3.417Z",
    fill: "#e8ffff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30",
    d: "M62.564 47.596a32.846 32.846 0 0 0 3.394-15.791c-.045-.191-.079-.387-.128-.577l-.411.02a36.62 36.62 0 0 1-10.856 21.443 32.2 32.2 0 0 1-20.482 8.775 32.192 32.192 0 0 1-21.24-6.732A36.529 36.529 0 0 1 .065 34.911a32.967 32.967 0 0 0 18.32 27.655 32.984 32.984 0 0 0 44.179-14.97Z",
    fill: "#86fffd"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 32.984,
    cy: 32.984,
    transform: "translate(.006 .007)",
    fill: "none",
    r: 32.984
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#85fffd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "M20.425 19.265a21.729 21.729 0 0 1 4.313-4.011 21.533 21.533 0 0 1 12.587-7.373c-.183-.032-.358-.082-.542-.11a21.526 21.526 0 0 0-4.639-.189 21.544 21.544 0 0 0-11.719 11.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M19.225 45.586a21.733 21.733 0 0 1-4.01-4.314 21.527 21.527 0 0 1-7.371-12.584c-.031.183-.082.357-.11.542a21.585 21.585 0 0 0-.189 4.639 21.547 21.547 0 0 0 11.68 11.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M46.747 20.467a21.7 21.7 0 0 1 4.01 4.313 21.527 21.527 0 0 1 7.371 12.584c.032-.182.082-.357.11-.542a21.585 21.585 0 0 0 .189-4.639 21.542 21.542 0 0 0-11.68-11.716Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M45.545 46.787a21.729 21.729 0 0 1-4.313 4.011 21.539 21.539 0 0 1-12.585 7.371c.183.031.358.082.542.109a21.471 21.471 0 0 0 4.64.189 21.542 21.542 0 0 0 11.716-11.68Z"
  })))));
};

export default SvgOrbV2;